module.exports = __webpack_public_path__ + "img/filete_con_almejas.3e359a2e.jpg";